import { 
    Box ,
    Button,
    Stack,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    Flex,
    Divider,
    Text
} from "@chakra-ui/react";
import { AiFillDelete, AiOutlineEdit } from "react-icons/ai";
import TablePaginator from "./TablePaginator";
import { CgTrash } from "react-icons/cg";
import { useDispatch } from "react-redux";
import moment from "moment";

const ProductsTable = ({data, deletehandler, editHandler, listProducts, searchTerm, setSearchTerm}) => {

  const dispatch = useDispatch()

  const cleanFilters = () => {
    setSearchTerm('')
    dispatch(listProducts())
  }

  const getFormattedDate = (date) => {
    moment.locale('es')
    const data = moment(date).format('MM/DD/YYYY')
    return data
  }

  const getStoresNames = (stores) => {
    if(stores.length === 0) return ('-')
    const storesNames = stores.map(store => store.name)
    return storesNames.join('|')
  }

    if(data.docs?.length === 0) return (
      <Flex w='100%' justifyContent='center' alignItems='center' flexDir='column'>
        <Text mr='.3em'>No se encontraron productos</Text>
        <Button 
          variant='link' mt='10px'
          onClick={cleanFilters}
        >
          <Text mr='.3em'>Limpiar filtros</Text>
          <CgTrash />
        </Button>
      </Flex>
    )

    return (
        <Box overflowX="auto" w='100%' py='20px'>
        <Table className="productusers" variant="striped">
          <Thead>
            <Tr>
              <Th w="10%">Nombre</Th>
              <Th w="10%">Precio</Th>
              <Th w="10%">Stock</Th>
              <Th w="30%">Descripción</Th>
              <Th w="10%">Tiendas</Th>
              <Th w="10%">Creación</Th>
              <Th w="10%"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.docs.map((product) => (
              <Tr key={product._id}>
                <Td>{product.name}</Td>
                <Td>{product.price}</Td>
                <Td>{product.stock}</Td>
                <Td>{product.description}</Td>
                <Td>{getStoresNames(product.stores)}</Td>
                <Td>{getFormattedDate(product.createdAt)}</Td>
                <Td>
                  <Stack>
                      <Button
                        onClick={() => {
                          editHandler(product);
                        }}
                        w="100%"
                        leftIcon={<AiOutlineEdit size="16" />}
                        colorScheme="blue"
                        size="xs"
                      >
                        Editar
                      </Button>
                    <Button
                      w="100%"
                      colorScheme="red"
                      leftIcon={<AiFillDelete size="16" />}
                      size="xs"
                      onClick={() => {
                        deletehandler(product);
                      }}
                    >
                      Eliminar
                    </Button>
                  </Stack>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Flex flexDir='column' mt='20px'>
          <Divider mb='20px' />
          <TablePaginator 
            totalDocs={data.totalDocs}
            limit={data.limit}
            totalPages={data.totalPages}
            page={data.page}
            pagingCounter={data.pagingCounter}
            hasPrevPage={data.hasPrevPage}
            hasNextPage={data.hasNextPage}
            prevPage={data.prevPage}
            nextPage={data.nextPage}
            listProducts={listProducts}
            searchTerm={searchTerm}
          />
        </Flex>
      </Box>
    )
}

export default ProductsTable

